





































































































































































































































































































































import Vue from 'vue'
import Nav from '@/components/Nav.vue'
import RubriquesTreeEditor from '@/components/RubriquesTreeEditor.vue'
import { ApiResponse } from '@/interfaces'
import { mapState } from 'vuex'

interface ClientConfig {
  rubriques: any[]
  timelimit1: number | null
  timelimit2: number | null
  natures: any[]
  civilities: any[]
  categories: any[]
  drouot: string
  interencheres: string
  targets: any[]
  documentTypes: any[]
  abreviations: any[]
  plateforms: string
  eunomart: string
  onlinePayment: string
  paymentTypes: any[]
}

export default Vue.extend({
  components: { Nav, RubriquesTreeEditor },
  data() {
    return {
      busy: false,
      isDisabled: false,
      clientConfig: {
        rubriques: [],
        timelimit1: null,
        timelimit2: null,
        natures: [],
        civilities: [],
        categories: [],
        drouot: '',
        interencheres: '',
        targets: [],
        documentTypes: [],
        abreviations: [],
        plateforms: '',
        eunomart: '',
        onlinePayment: '',
        paymentTypes: [],
      } as ClientConfig,
      viewportWidth: 0,
      autocompleteNone: 'none',
      changeDetected: null as null | boolean,
      usersList: [] as any[],
      templatesList: [] as any[],
      batchList: [] as any[],
    }
  },
  computed: {
    ...mapState(['user', 'connectedAs']),
    isExeveAdmin(): boolean {
      return this.user !== null && (!!this.user.isAdmin || this.connectedAs !== null)
    },
    clientTitle(): string {
      return this.user?.client?.name || 'client'
    },
    clientId(): string | number {
      return this.user?.client?.id ?? ''
    },
    structuresList(): any[] {
      const configStructures = this.user?.client?.config?.structures
      if (Array.isArray(configStructures)) {
        return configStructures
      }

      const clientStructures = this.user?.client?.structures
      return Array.isArray(clientStructures) ? clientStructures : []
    },
    templatesByView(): Array<{ view: string; templates: any[] }> {
      const groups = this.templatesList.reduce((result: Array<{ view: string; templates: any[] }>, template: any) => {
        const view = template.view || 'other'
        const group = result.find((item) => item.view === view)

        if (group) {
          group.templates.push(template)
        } else {
          result.push({ view, templates: [template] })
        }

        return result
      }, [])

      groups.forEach((group) => {
        group.templates.sort((firstTemplate, secondTemplate) =>
          (firstTemplate.name || '').localeCompare(secondTemplate.name || '', 'fr', { sensitivity: 'base' })
        )
      })

      const viewOrder = [
        'inventory',
        'requisition',
        'requisition-item',
        'sale',
        'contact',
        'mail-document',
        'mail-invoice',
        'mail-seller',
        'mail-buyer',
        'invoice',
      ]

      groups.sort((firstGroup, secondGroup) => {
        const firstIndex = viewOrder.indexOf(firstGroup.view)
        const secondIndex = viewOrder.indexOf(secondGroup.view)
        const lastIndex = viewOrder.length

        return (firstIndex === -1 ? lastIndex : firstIndex) - (secondIndex === -1 ? lastIndex : secondIndex)
      })

      return groups
    },
  },
  watch: {
    user(newVal) {
      if (newVal?.client?.id) {
        this.fetchConfig()
      }
    },
    clientConfig: {
      deep: true,
      immediate: true,
      handler() {
        if (this.changeDetected === false) {
          this.changeDetected = true
        }
      },
    },
  },
  mounted() {
    this.viewportWidth = window.innerWidth
    if (this.user?.client?.id) {
      this.fetchConfig()
    }
    this.$nextTick(() => {
      this.changeDetected = false
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    setAttribute() {
      this.autocompleteNone = 'none'
    },
    onResize() {
      this.viewportWidth = window.innerWidth
    },
    cancelForm() {
      this.$router.push({ name: 'home' })
    },
    goToClient() {
      this.$router.push({ name: 'client' })
    },
    fetchConfig() {
      if (!this.user?.client?.id) {
        return
      }
      this.$api
        .get(`/client/${this.user.client.id}/config`)
        .then((response) => {
          const clientData = response.data.data
          this.usersList = Array.isArray(clientData.users) ? clientData.users : []
          this.templatesList = Array.isArray(clientData.templates) ? clientData.templates : []
          this.batchList = Array.isArray(clientData.batches) ? clientData.batches : []
          this.setClientConfig(clientData.config || {})
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            title: 'Erreur',
            message: 'Impossible de charger la configuration.',
          })
        })
    },
    isUserInactive(user: any): boolean {
      if (!user.licenceExpirationDate) return false
      const expDate = new Date(user.licenceExpirationDate)
      return expDate < new Date()
    },
    getMinutesUntilUnlock(user: any): number | null {
      if (!user.loginLockedUntil) return null
      const lockedUntil = new Date(user.loginLockedUntil)
      const now = new Date()
      const diffMs = lockedUntil.getTime() - now.getTime()
      if (diffMs <= 0) return 0
      return Math.ceil(diffMs / 60000)
    },
    getUserAvatarUrl(user: any): string {
      if (!user.avatar) return ''
      const timestamp = Date.now()
      return `${process.env.VUE_APP_API_URL}/user/${user.id}/avatar?t=${timestamp}`
    },      setClientConfig(config: any) {
      if (config) {
        this.clientConfig = {
          rubriques: Array.isArray(config.rubriques) ? config.rubriques : [],
          timelimit1: config.timelimit1 ?? null,
          timelimit2: config.timelimit2 ?? null,
          natures: Array.isArray(config.natures) ? config.natures : [],
          civilities: Array.isArray(config.civilities) ? config.civilities : [],
          categories: Array.isArray(config.categories) ? config.categories : [],
          drouot: typeof config.drouot === 'string' ? config.drouot : JSON.stringify(config.drouot ?? {}),
          interencheres: typeof config.interencheres === 'string' ? config.interencheres : JSON.stringify(config.interencheres ?? {}),
          targets: Array.isArray(config.targets) ? config.targets : [],
          documentTypes: Array.isArray(config.documentTypes) ? config.documentTypes : [],
          abreviations: Array.isArray(config.abreviations) ? config.abreviations : [],
          plateforms:
            typeof config.plateforms === 'string'
              ? config.plateforms
              : JSON.stringify(config.plateforms ?? []),
          eunomart: typeof config.eunomart === 'string' ? config.eunomart : JSON.stringify(config.eunomart ?? {}),
          onlinePayment:
            typeof config.onlinePayment === 'string'
              ? config.onlinePayment
              : JSON.stringify(config.onlinePayment ?? config.online_payment ?? {}),
          paymentTypes: Array.isArray(config.paymentTypes) ? config.paymentTypes : [],
        }
      }
    },
    formatAddress(structure: any) {
      const line1 = structure.address || ''
      const line2 = structure.address2 || ''
      const cityLine = [structure.postalCode, structure.city].filter(Boolean).join(' ')
      return [line1, line2, cityLine].filter(Boolean).join(', ')
    },
    getStructureLogoUrl(structure: any): string {
      const timestamp = Date.now()
      return `${process.env.VUE_APP_API_URL}/structure/${structure.id}/logo?t=${timestamp}`
    },
    goToStructure(structure: any) {
      if (!structure?.id) {
        return
      }
      this.$router.push({ name: 'structure', params: { id: structure.id } })
    },
    goToUser(user: any) {
      if (!user?.id) {
        return
      }
      this.$router.push({ name: 'user', params: { id: user.id } })
    },
    goToTemplate(template: any) {
      if (!template?.id) {
        return
      }
      this.$router.push({ name: 'template', params: { id: template.id } })
    },
    templateViewLabel(view: string): string {
      const labels: Record<string, string> = {
        inventory: 'Inventaires',
        requisition: 'Réquisitions',
        'requisition-item': 'Lots',
        sale: 'Ventes',
        contact: 'Contacts',
        'mail-document': 'Email document',
        'mail-invoice': 'Email facture',
        'mail-seller': 'Email vendeur',
        'mail-buyer': 'Email acheteur',
        invoice: 'Facture',
      }

      if (labels[view]) {
        return labels[view]
      }

      if (view === 'other') {
        return 'Autres'
      }

      return view.charAt(0).toUpperCase() + view.slice(1).replace(/[-_]/g, ' ')
    },
    goBack() {
      this.$router.back()
    },
    deleteBatch(batch: any) {
      this.$confirm(`Supprimer le batch "${batch.name}" ?`, 'Confirmation', {
        confirmButtonText: 'Supprimer',
        cancelButtonText: 'Annuler',
        type: 'warning',
      }).then(() => {
        this.$api
          .delete(`/client/${this.user.client.id}/batch/${batch.id}`)
          .then(() => {
            this.batchList = this.batchList.filter((b: any) => b.id !== batch.id)
            this.$message.success('Batch supprimé')
          })
          .catch(() => {
            this.$message.error('Erreur lors de la suppression du batch')
          })
      }).catch(() => null)
    },
    submit() {
      // Parse JSON strings from clientConfig
      const configToSubmit: Record<string, unknown> = { ...this.clientConfig }
      const jsonFields: Array<{ key: string; label: string }> = [
        { key: 'drouot', label: 'Drouot' },
        { key: 'interencheres', label: 'Interenchères' },
        { key: 'plateforms', label: 'Plateforms' },
        { key: 'eunomart', label: 'Eunomart' },
        { key: 'onlinePayment', label: 'Paiement en ligne' },
      ]
      let invalidJsonField: string | null = null

      jsonFields.forEach(({ key, label }) => {
        const value = configToSubmit[key]
        if (typeof value === 'string') {
          if (value.trim() === '') {
            configToSubmit[key] = []
            return
          }

          try {
            const parsedValue = JSON.parse(value)
            if (parsedValue === null || typeof parsedValue !== 'object') {
              invalidJsonField = label
              return
            }
            configToSubmit[key] = parsedValue
          } catch {
            invalidJsonField = label
          }
        }
      })

      if (invalidJsonField) {
        this.$notify({
          type: 'error',
          title: 'Erreur',
          message: `Le champ ${invalidJsonField} doit contenir un JSON valide (objet ou tableau).`,
        })
        return
      }

      this.busy = true
      const loading = this.$loading({
        target: '.form-panel',
        text: 'Chargement des données...',
      })

      // Rubriques is already an array, no need to parse
      configToSubmit.rubriques = this.clientConfig.rubriques
      configToSubmit.natures = this.clientConfig.natures
      configToSubmit.civilities = this.clientConfig.civilities
      configToSubmit.categories = this.clientConfig.categories
      configToSubmit.targets = this.clientConfig.targets
      configToSubmit.documentTypes = this.clientConfig.documentTypes
      configToSubmit.abreviations = this.clientConfig.abreviations
      configToSubmit.paymentTypes = this.clientConfig.paymentTypes

      // API expects snake_case for online payment config.
      configToSubmit.online_payment = configToSubmit.onlinePayment
      delete configToSubmit.onlinePayment

      // Submit client config
      this.$api
        .put(`/client/${this.user.client.id}/config`, configToSubmit)
        .then((response) => {
          const apiResponse = response.data

          this.setClientConfig(apiResponse.data)
          this.$notify({
            type: 'success',
            title: 'Succès',
            message: 'Configuration cliente modifiée avec succès !',
          })
        })
        .catch((error) => {
          if (error.response) {
            const apiResponse = error.response.data as ApiResponse

            this.$notify({
              type: 'error',
              title: 'Erreur',
              message:
                apiResponse.message ?? 'Une erreur est survenue. Veuillez nous excuser pour la gêne occasionnée.',
            })
          }
        })
        .finally(() => {
          this.busy = false
          this.changeDetected = false
          loading.close()
        })
    },
  },
})
